import React from 'react';
import { Helmet } from 'react-helmet';

import { css } from '@emotion/react';

import { Footer } from '../components/Footer';
import SiteNav from '../components/header/SiteNav';
import { PostFullContent } from '../components/PostContent';
import { Wrapper } from '../components/Wrapper';
import IndexLayout from '../layouts';
import {
  inner,
  outer,
  SiteArchiveHeader,
  SiteHeader,
  SiteMain,
  SiteNavMain,
} from '../styles/shared';
import { NoImage, PostFull, PostFullHeader, PostFullTitle } from '../templates/post';
import { colors } from '../styles/colors';

const PageTemplate = css`
  .site-main {
    margin-top: 64px;
    padding-bottom: 4vw;
    background: #fff;
  }

  @media (prefers-color-scheme: dark) {
    .site-main {
      /* background: var(--darkmode); */
      background: ${colors.darkmode};
    }
  }
`;

const About: React.FC = () => (
  <IndexLayout>
    <Helmet>
      <title>About</title>
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header className="site-archive-header no-image" css={[SiteHeader, SiteArchiveHeader]}>
        <div css={[outer, SiteNavMain]}>
          <div css={inner}>
            <SiteNav isHome={false} />
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <div css={inner}>
          <article className="post page" css={[PostFull, NoImage]}>
            <PostFullHeader className="post-full-header">
              <PostFullTitle className="post-full-title">About</PostFullTitle>
            </PostFullHeader>

            <PostFullContent className="post-full-content">
            <div className="post-content">
                <p>
                  Hey! I'm Sergio. I'm a computer engineer with a master's degree in IA.
                I worked for 10 years at <a href="https://www.qrr.es">www.qrr.es</a>. We made quantitave software that runs extremely
                fast on modest hardware.
                </p>
                <p>
                  Five years ago I started to work at <a href="https://www.playtomic.io">www.playtomic.io</a>.
                It is probably one of the most
                interesting places to be in Spain right now: we are trying to change how people
                meet to practice sport.
                </p>
                <p>
                  In the meanwhile, I worked for 4 years as partial-time photographer. You can see my <em>second life</em> at <a href="https://www.sergiomoratilla.com">www.sergiomoratilla.com</a>
                </p>
                <p>
                  My social networks:
                </p>
                <ul>
                 <li>Twitter: <a href="https://www.twitter.com/sgmoratilla">@sgmoratilla</a></li>
                 <li>GitHub: <a href="https://www.github.com/sgmoratilla">@sgmoratilla</a></li>
                </ul>
                <p>
                <a href="https://www.getmanfred.com/profile/sgmoratilla">This is my CV</a>, in case that you are looking for it.
                </p>
              </div>
            </PostFullContent>
          </article>
        </div>
      </main>
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default About;
